import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss'],
})
export class PageNotFoundComponent {
  is404 = false;

  constructor(route: ActivatedRoute) {
    if (route.snapshot.url[0]?.path == 'pagenotfound') {
      this.is404 = true;
    }
  }
}
